import { useLanguage } from '@/hooks/useLanguage';
import useIsDailyPlanPage from '@/services/plans/hooks/useIsDailyPlanPage';
import { IconCheckmarkSingle, IconPlus } from '@/theme/icons';
import rem from '@/utils/rem';
import { Button, Icon, SpaceProps, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  isActive: boolean;
} & SpaceProps;
function ScheduleButton({ onClick, isActive, ...rest }: Props) {
  const { t } = useTranslation('ScheduleButton');
  const { currentLanguage } = useLanguage();
  const isDailyPlanPage = useIsDailyPlanPage();
  const dayOrWeek = isDailyPlanPage ? t('labels.thisDay') : t('labels.thisWeek');

  return (
    <Button
      width={currentLanguage === 'es' ? rem(100) : rem(90)}
      height={rem(24)}
      minHeight={rem(24)}
      background="background-primary"
      borderColor={isActive ? 'background-secondary' : 'stroke-primary'}
      borderRadius={rem(6)}
      _hover={{
        backgroundColor: 'background-secondary',
        cursor: 'pointer',
      }}
      _disabled={{
        _hover: {
          backgroundColor: 'background-secondary',
          cursor: 'default',
        },
      }}
      cursor={isActive ? 'default' : 'inherit'}
      backgroundColor={isActive ? 'background-secondary' : 'background-primary'}
      isDisabled={isActive}
      leftIcon={<Icon as={!isActive ? IconPlus : IconCheckmarkSingle} boxSize={rem(10)} color="text-primary" />}
      onClick={onClick}
      paddingX="0"
      variant="secondary"
      {...rest}
    >
      <Text textStyle="small" color="text-primary">
        {!isActive ? dayOrWeek : t('labels.added')}
      </Text>
    </Button>
  );
}

export default memo(ScheduleButton);
